import { render, staticRenderFns } from "./Dmesg.vue?vue&type=template&id=b61b51fe&scoped=true"
import script from "./Dmesg.vue?vue&type=script&lang=js"
export * from "./Dmesg.vue?vue&type=script&lang=js"
import style0 from "./Dmesg.vue?vue&type=style&index=0&id=b61b51fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61b51fe",
  null
  
)

export default component.exports